import type { IRotatedBox, ISelected } from '@/editor/types';
import { EEntityType } from '@/editor/types';
import { getRotatedRectangleVertices } from '@/editor/math/utils';

/** 根据传入的状态获取多选的包围盒 */
export function getMultiSelectedBoxByState(dataList: IRotatedBox[]): IRotatedBox {
  const veticesData = dataList
    .map(({ width, thickness, center, rotation }) => getRotatedRectangleVertices(width, thickness, center, rotation))
    .flat();

  const minX = Math.min(...veticesData.map((data) => data.x));
  const maxX = Math.max(...veticesData.map((data) => data.x));
  const minY = Math.min(...veticesData.map((data) => data.y));
  const maxY = Math.max(...veticesData.map((data) => data.y));
  const center = { x: (minX + maxX) / 2, y: (minY + maxY) / 2 };
  const width = maxX - minX;
  const thickness = maxY - minY;
  const rotation = 0;

  return {
    width,
    thickness,
    center,
    rotation
  };
}

export function isFurnitureOrAssembly(selected: Pick<ISelected, 'type'>): boolean {
  return [EEntityType.Assembly, EEntityType.Furniture].includes(selected.type);
}
